// extracted by mini-css-extract-plugin
export default {"container":"j1-z","heading":"k1-z","links":"l1-z","copy":"m1-z","subCopy":"n1-z","linksLeft":"o1-z","linksCenter":"p1-z","linksRight":"q1-z","link":"r1-z","onlyLink":"s1-z"};